import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { RunConfig } from '../../../DataStructures/RunConfiguration/RunConfig';

@Component({
  selector: 'app-advanced-settings-dialog',
  templateUrl: './advanced-settings-dialog.component.html',
  styleUrls: ['./advanced-settings-dialog.component.css']
})
export class AdvancedSettingsDialogComponent implements OnInit {

  runConfig:RunConfig;
  constructor(private dialog: MatDialog,
    public dialogRef: MatDialogRef<AdvancedSettingsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: RunConfig) {
      this.runConfig = data;
    }

  ngOnInit() {

  }

  save(){
    this.dialogRef.close(this.runConfig);
  }

}



// WEBPACK FOOTER //
// ./src/app/admin-dashboard/optimizer/advanced-settings-dialog/advanced-settings-dialog.component.ts